module.exports = __webpack_public_path__ + "static/media/dolomiten.2e42d7e9.svg";